import { Alert as DigdirAlert, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
import { useState } from "react";
import { Button, Icon } from "../index.js";
const Alert = React.forwardRef(({ "data-color": dataColor = "info", "data-size": dataSize = "md", closeButton = false, children, onClose, className, ...props }, ref) => {
    const [closed, setClosed] = useState(false);
    return (!closed && (React.createElement(DigdirAlert, { className: cn("in-alert", className), "data-color": dataColor, "data-size": dataSize, ref: ref, ...props },
        closeButton !== false && (React.createElement(Button, { className: cn("in-alert__close", `in-alert__close--${dataColor}`), icon: true, "data-color": "neutral", variant: "tertiary", onClick: () => {
                onClose === null || onClose === void 0 ? void 0 : onClose();
                setClosed(true);
            }, "aria-label": closeButton === true ? "Lukk varsel" : closeButton },
            React.createElement(Icon, { prefix: "fasr", iconName: "xmark", size: "xs" }))),
        children)));
});
Alert.displayName = "Alert";
export { Alert };
//# sourceMappingURL=alert.js.map